function applyDiscount(discount, event) {
    // console.log(">>>>getdiscount", discount);
    let checkoutUrl = '/discount/';
     if(discount) checkoutUrl = checkoutUrl + discount +'?redirect=/cart'; 
    let checkoutContainer = document.createElement('div');
    fetch(checkoutUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        // console.log("data>> ", data);
        checkoutContainer.innerHTML = data;
        $('[data-action="apply-discount"].loading').removeClass('loading');
        $('.discount-error-status').html('');
        let cart_datajson = checkoutContainer.querySelector('[cart-data-json]').innerHTML;
        let main_cart_footer = checkoutContainer.querySelector('#main-cart-footer').innerHTML;
        let cart_itemsHtml = checkoutContainer.querySelector('cart-items').innerHTML;
        let CarDrawerHtml = checkoutContainer.querySelector('cart-drawer').innerHTML;
         cart_datajson = JSON.parse(cart_datajson);
         console.log(">>>>cart_datajson", cart_datajson);
        if(cart_datajson.total_discount > 0){
            let mainCartFooter = document.querySelector('#main-cart-footer');
            if(mainCartFooter)mainCartFooter.innerHTML = main_cart_footer;
            let cartItems = document.querySelector('cart-items');
            if(cartItems)cartItems.innerHTML = cart_itemsHtml;
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            if(cartDrawerWrapper) cartDrawerWrapper.innerHTML = CarDrawerHtml;
            let firstInputQnt = $('.cart-item__quantity input.quantity__input');
            if(firstInputQnt)
            firstInputQnt[0].dispatchEvent(new Event('change', { bubbles: true }));
        }else{
          // console.log("discount>>>", discount);
            //$('coupon-drawer .drawer__close').trigger('click');
            let mainCartFooter = document.querySelector('#main-cart-footer');
            if(mainCartFooter)mainCartFooter.innerHTML = main_cart_footer;
            let cartItems = document.querySelector('cart-items');
            if(cartItems)cartItems.innerHTML = cart_itemsHtml;
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            if(cartDrawerWrapper) cartDrawerWrapper.innerHTML = CarDrawerHtml;
            if(discount != 'nodiscount'){
              // event.preventDefault();
              $('.discount-error-status').html(`<b>${discount}</b> discount code is not valid for the items in your cart`);
             }
            let firstInputQnt = $('.cart-item__quantity input.quantity__input');
            if(firstInputQnt)firstInputQnt[0].dispatchEvent(new Event('change', { bubbles: true }));
            // document.dispatchEvent(new CustomEvent("cart:refresh")); 
        }
       
      })
  }

// To Apply the Discount
$('body').on('click','[data-action="apply-discount"]', function(e){
    let discount_code =   $(this).parents('.cart-discount').find('input').val().trim();
    console.log('discount_code', discount_code);
    if(discount_code){
        $(this).addClass('loading');
        applyDiscount(discount_code);
    }else{
        document.querySelector(".discount-error-status").innerHTML = 'Please enter coupon code'; // For discount input field
        // $(this).addClass('loading');
    }
});

// 
$('input.coupon_input_field').keyup(function(){
  document.querySelector(".discount-error-status").innerHTML = '';
});

// To Remove Applied discount
$('body').on('click', '[data-action="remove-discount"]', function(e){
    e.preventDefault();
    $(this).addClass('loading');
    applyDiscount('nodiscount',e);
});